import React, { useState } from "react";

import { ListTable } from "../Table/listTable/listTable";
import { useGetAllResults } from "../../hooks/resultsHooks/results.hooks";
import { resultListTitles } from "../../Constants/tableTitles/ListTableTitle/ResultList.titles";
import { transformResultListTableData } from "../../Services/transformer/transformResultListTableData";
import { getValue } from "../../utils/object.utils";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../Constants/paths";

export const ListResults = () => {
  const [pageToSearch, setPageToSearch] = useState(1);

  const { isLoading: isBrancheListLoading, data } = useGetAllResults({
    page: pageToSearch,
  });

  const navigate = useNavigate();

  const handleResultSelected = (selectedResult: any) => {
    const resultId = getValue(selectedResult, "id");
    if (!resultId) return;

    navigate(`${Paths.ResultDetails}?resultId=${resultId}`);
  };

  return (
    <ListTable
      titles={resultListTitles}
      data={data?.result}
      isDataLoading={isBrancheListLoading}
      transformFn={transformResultListTableData}
      pagination={{
        onPageChange: (pageNo) => {
          setPageToSearch(pageNo);
        },
        totalPage: data?.lastPage,
      }}
      onRowClick={handleResultSelected}
    />
  );
};
